(() => {
  const loadImage = (image) => {
    if (!image || image.dataset.kcpcLoaded === "true") return;

    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.src) image.src = image.dataset.src;
    image.dataset.kcpcLoaded = "true";
  };

  const loadVideo = (video) => {
    if (!video || video.dataset.kcpcLoaded === "true") return;

    video.querySelectorAll("source[data-src]").forEach((source) => {
      source.src = source.dataset.src;
    });
    if (video.dataset.src) video.src = video.dataset.src;
    video.dataset.kcpcLoaded = "true";
    video.load();
  };

  const getDeferredMedia = (root = document) => new Set([
    ...root.querySelectorAll("img[data-kcpc-deferred-image], video[data-src]"),
    ...[...root.querySelectorAll("video source[data-src]")].map(
      (source) => source.closest("video"),
    ),
  ]);

  const deferredMedia = getDeferredMedia();

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          if (entry.target.tagName === "IMG") loadImage(entry.target);
          if (entry.target.tagName === "VIDEO") loadVideo(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "300px 150px" },
    );

    const observeDeferredMedia = (root = document) => {
      getDeferredMedia(root).forEach((media) => {
        if (media) observer.observe(media);
      });
    };

    deferredMedia.forEach((media) => observer.observe(media));

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches?.("img[data-kcpc-deferred-image], video[data-src]")) {
            observer.observe(node);
          }
          observeDeferredMedia(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  } else {
    deferredMedia.forEach((media) => {
      if (media.tagName === "IMG") loadImage(media);
      if (media.tagName === "VIDEO") loadVideo(media);
    });
  }

  const loadCardHoverImage = (target) => {
    const card = target.closest("product-card");
    loadImage(card?.querySelector("img[data-kcpc-hover-image]"));
  };

  document.addEventListener("pointerover", (event) => {
    if (event.target.closest("product-card")) loadCardHoverImage(event.target);
  }, { passive: true });

  document.addEventListener("focusin", (event) => {
    if (event.target.closest("product-card")) loadCardHoverImage(event.target);
  });
})();
